import tw from 'tailwind-styled-components';
import styled from 'styled-components';
import { Title } from '../Typography';
import { ReactNode, type Ref } from 'react';

const MenuWrapperBase = tw.section`
  fixed
  inset-0
  p-0
  md:left-auto
  md:inset-y-0
  md:w-filterNav
  bg-corporate-offWhite
  flex
  flex-col
  top-headerMobile
  md:top-header
  transition-all
  duration-500
  ease-in-out
`;

export const MenuWrapper = styled(MenuWrapperBase)<{ $isOpen: boolean }>`
  right: ${({ $isOpen }) => ($isOpen ? 0 : '-39.125rem')};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  z-index: ${({ $isOpen }) => ($isOpen ? 60 : 0)};
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
`;

export const FilterHeader = tw.header`
  bg-corporate-offWhite
  top-0
  inset-x-0
  flex
  flex-row
  flex-wrap
  p-5
  pb-0
  md:p-20
  md:pb-5
`;

export const FilterContent = styled.div<{
  children?: ReactNode;
  ref?: Ref<HTMLElement>;
}>`
  overflow-y: auto;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-bottom: 13rem;
  position: relative;
  z-index: 1;

  @media (min-width: 768px) {
    padding-left: 5rem;
    padding-right: 5rem;
    padding-bottom: 5rem;
  }
`;

export const Break = styled.div`
  flex-basis: 100%;
  height: 0;
`;

export const FiltersTitle = styled(Title)`
  width: 200px;
  @media (min-width: 768px) {
    width: auto;
    margin-right: 1.875rem;
  }
  order: 1;
`;

export const ClearButtonLayoutHelper = styled.div`
  display: flex;
  order: 4;
  flex-basis: 100%;
  padding: 1rem;
  justify-content: center;

  @media (min-width: 768px) {
    order: 2;
    flex-basis: auto;
    padding: 0;
    justify-content: start;
  }
`;

export const ClearFilterButton = styled.button<{
  children?: ReactNode;
  className?: string;
  type?: string;
  onClick?: () => void;
}>`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: start;

  &::after {
    content: '';
    height: 1px;
    background-color: #292b29;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }

  svg {
    width: 10px;
    height: 10px;
    margin-right: 0.25rem;
  }
`;

export const CloseButton = styled.button<{
  children?: ReactNode;
  type?: string;
  onClick?: () => void;
}>`
  margin-left: auto;
  order: 3;
  svg {
    width: 24px;
    height: 24px;
  }
`;

export const FilterTopicWrapper = styled.div<{
  children?: ReactNode;
  className?: string;
}>`
  padding-bottom: 0.625rem;
`;

export const FilterCheckOption = styled.label<{
  children?: ReactNode;
  htmlFor?: string;
}>`
  display: block;
  margin-top: 0;
  margin-bottom: 1.25rem;
  display: flex;
  flex-direction: row;
  align-items: center;

  input[type='checkbox'] {
    width: 34px;
    height: 34px;
    border: 2px solid #5a5e5a;
    border-radius: 4px;
    margin-right: 1.25rem;

    &:checked {
      border-color: rgba(1, 14, 84, 1);
      background-color: rgba(1, 14, 84, 1);
    }
  }
`;

export const RatingsStars = styled.div`
  display: inline-block;
  margin-right: 0.25rem;
  svg {
    width: 22px;
    height: 22px;
    margin-right: 0.5rem;
    display: inline-block;
  }
`;

export const ExpandableTagList = styled.div`
  display: none;
  padding: 1.625rem 0 0;
  margin-bottom: 2.5rem;

  @media (min-width: 768px) {
    display: block;
  }
`;

export const TagListWrapper = styled.div<{ $expanded?: boolean; children?: ReactNode }>`
  overflow: hidden;
  max-height: ${({ $expanded = false }) => ($expanded ? 'auto' : '114px')};
  margin-bottom: 0.75rem;
`;

export const MobileApplyButtonWrapper = styled.div`
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.52) 28%,
    rgba(255, 255, 255, 1) 54%
  );
  padding: 3.5rem 0;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  font-size: 12px;

  @media (min-width: 768px) {
    display: none;
  }

  > button {
    margin-left: 50%;
    transform: translateX(-50%);
    > span {
      height: 3.8rem;
      padding: 0 1.5rem;
      display: inline-flex;
      border-radius: 2rem;
      background: #010e54;
      text-transform: uppercase;
      align-items: center;
      color: white;
      font-size: 12px;
      letter-spacing: 0.1em;
      position: relative;
      white-space: nowrap;
      &:after {
        content: '';
        position: absolute;
        top: 5px;
        left: 5px;
        right: 5px;
        bottom: 5px;
        border-radius: 2rem;
        border: 1px solid #fff;
      }
    }
  }
`;

export const DrawerOverlay = tw.div`
  bg-black
  h-full
  fixed
  left-0
  w-full
  bg-opacity-75
  block
  transition-all
  duration-500
  ease-in-out
  drawer-overlay
  top-header
  focus:outline-none
  focus:border-red-300
  focus:ring
  z-20
`;
